export const ScoreTypes = {
    accuracy: {
        title: 'Doğruluk',
        unit: '%',
        fixed: 2,
        bgcolor: 'info'
    },
    wordsPerMinute: {
        title: 'DBK',
        unit: 'k/dk',
        fixed: 0,
        bgcolor: 'success'
    },
    duration: {
        title: 'Süre',
        unit: 'sn',
        fixed: 2,
        bgcolor: 'warning'
    },

}